import React from 'react';
import Icon from '../../../components/AppIcon';

const MarketPulseCard = ({ title, value, change, changeType, icon, description }) => {
  const getChangeColor = () => {
    if (changeType === 'positive') return 'text-success';
    if (changeType === 'negative') return 'text-error';
    return 'text-text-secondary';
  };

  const getChangeIcon = () => {
    if (changeType === 'positive') return 'TrendingUp';
    if (changeType === 'negative') return 'TrendingDown';
    return 'Minus';
  };

  return (
    <div className="card-elevated p-6 hover:shadow-executive-hover transition-all duration-300">
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center space-x-3">
          <div className="w-12 h-12 gradient-executive rounded-lg flex items-center justify-center">
            <Icon name={icon} size={24} color="white" />
          </div>
          <div>
            <h3 className="font-headline font-semibold text-lg text-text-primary">{title}</h3>
            <p className="text-sm text-text-secondary">{description}</p>
          </div>
        </div>
      </div>
      
      <div className="flex items-end justify-between">
        <div className="text-3xl font-headline font-bold text-text-primary">{value}</div>
        <div className={`flex items-center space-x-1 ${getChangeColor()}`}>
          <Icon name={getChangeIcon()} size={16} />
          <span className="text-sm font-medium">{change}</span>
        </div>
      </div>
    </div>
  );
};

export default MarketPulseCard;